import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ReserRoomvailabilityList } from "../../Services/Service";

export const fetchRoomAvailability = createAsyncThunk(
  "roomAvailability/fetchRoomAvailability",
  async (
    {
      PropertyID,
      CheckInDate,
      CheckoutDate,
      RateTypeCode,
      RateCodeID,
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await ReserRoomvailabilityList(
        PropertyID,
        CheckInDate,
        CheckoutDate,
        RateTypeCode,
        RateCodeID
      );

      return response?.Data || [];
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ReservationRoomAvalSlice = createSlice({
  name: "roomAvailability",
  initialState: {
    roomList: [],
    loading: false,
    error: null,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchRoomAvailability.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchRoomAvailability.fulfilled, (state, action) => {
        state.loading = false;
        state.roomList = action.payload;
      })

      .addCase(fetchRoomAvailability.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default ReservationRoomAvalSlice.reducer;